<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container pb-0">
                <div class="page-name">
                    {{departmentData[0].site_name}} 
                    <button type="button" title='Print' v-on:click.prevent="print(company,location)" class="btn btn-primary waves-effect pull-right"><i class="fa fa-print" aria-hidden="true"></i></button>
                </div>
            </div>
            <div class="admin-page-content"> <!--class = "admin-page-content sidebar-right"-->
                <!--page content-->
                <div class="internal-container contact-container">
                    <template>
                        <swiper class="" :options="swiperOptionDepartments" ref="swiperDepartment">
                            <template v-for="(dept, index) in departmentData">
                                <swiper-slide class="dept" :id="'dept_'+dept.department_id" v-bind:key="'dept_'+index">
                                    <span class="dept_name" v-on:click.prevent="selectDepartment(dept.department_id)">
                                        {{dept.dept_name}}
                                    </span>
                                </swiper-slide>
                            </template>
                            <div class="swiper-button-prev fa fa-chevron-left color-055587" slot="button-prev"></div>
                            <div class="swiper-button-next fa fa-chevron-right color-055587" slot="button-next"></div>
                        </swiper>
                    </template>
                    <template v-if="department_id != 0 && windowWidth <= 767">
                        <template v-if="department_id != 0">
                            <template v-for="(dept_cont, index) in departmentData">
                                <template v-if="dept_cont.department_id == department_id">
                                    <div class="sidebar-locations">
                                        {{dept_cont.dept_name}}
                                    </div>
                                    <template v-if="dept_cont.note !='' || dept_cont.address_line != '' || dept_cont.contacts.length > 0">
                                        <div v-if="dept_cont.address_line != ''" class="sidebar-locations-details mt-0 mb-0">
                                            <img src="/static/images/map-pin.png">
                                            {{dept_cont.address_line}}
                                        </div>
                                        <div class="sidebar-locations-details mt-0 mb-0" v-if="dept_cont.note != ''">
                                            Note : {{dept_cont.note}}
                                        </div>
                                        <div class="sidebar-locations-details mt-0 mb-0" v-show="dept_cont.contacts[0].contact_label != ''">
                                            {{dept_cont.contacts[0].contact_label}} : {{dept_cont.contacts[0].contact}}
                                        </div>
                                        <template v-if="dept_cont.contacts.length > 1">
                                            <template v-for="(cont, index1) in dept_cont.contacts">
                                                <template v-if="index1 != 0">
                                                    <div class="sidebar-locations-details mt-0 mb-0" v-if="cont.contact_label != ''">
                                                        {{cont.contact_label}} : {{cont.contact}}
                                                    </div>
                                                </template>
                                            </template>
                                        </template>
                                        <div class="sidebar-locations-details mt-0 mb-1"></div>
                                    </template>
                                    <template v-else>
                                        <div class="sidebar-locations-details">
                                            {{noDataMessaage}}
                                        </div>    
                                    </template>
                                </template>
                            </template>
                        </template>
                        <!--<div class="sidebar-locations">
                            {{departmentData[0].site_name}}
                        </div>
                        <template v-if="departmentData[0].site_note != '' || departmentData[0].site_address_line != '' || departmentData[0].site_contacts.length > 0">
                            <div v-if="departmentData[0].site_address_line != ''" class="sidebar-locations-details mt-0 mb-0">
                                <img src="/static/images/map-pin.png">
                                {{departmentData[0].site_address_line}}
                            </div>
                            <div v-if="departmentData[0].site_note != ''" class="sidebar-locations-details mt-0 mb-0">
                                Note : {{departmentData[0].site_note}}
                            </div>
                            <template v-if="departmentData[0].site_contacts.length > 0">
                                <div class="sidebar-locations-details mt-0 mb-0" v-show="departmentData[0].site_contacts[0].contact_label != ''">
                                    {{departmentData[0].site_contacts[0].contact_label}} : {{departmentData[0].site_contacts[0].contact}}
                                </div>
                                <template v-show="departmentData[0].site_contacts.length > 1">
                                    <template v-for="(cont, index) in departmentData[0].site_contacts">
                                        <template v-if="index != 0">
                                            <div class="sidebar-locations-details mt-0 mb-0" v-if="cont.contact_label != ''">
                                                {{cont.contact_label}} : {{cont.contact}}
                                            </div>
                                        </template>
                                    </template>
                                </template>
                                <div class="sidebar-locations-details mt-0 mb-1"></div>
                            </template>
                        </template>
                        <template v-else>
                            <div class="sidebar-locations-details">
                                {{noDataMessaage}}
                            </div>    
                        </template>-->
                    </template>
                    <div class="app-filter-good-table-container">
                        <!-- List Content Here -->
                        <vue-good-table
                            ref="ContactExtensionList"
                            mode="remote"
                            title="Contact Extension List"
                            @on-page-change="onPageChange"
                            @on-selected-rows-change="selectionChanged"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            @on-sort-change="onSortChange"
                            @on-row-click="onRowClick"
                            :totalRows="totalRecords"
                            :columns="columns"
                            :rows="rows"
                            :pagination-options="{
                            enabled: true,
                            mode: 'pages',
                            pageLabel: 'Page',
                            position: 'bottom',
                            perPage: serverParams.perPage,
                            perPageDropdown: [25, 50, 100, 200 ,500],
                            dropdownAllowAll: false,
                            }"

                            :search-options="{
                            enabled: false,
                            }">
                    </vue-good-table>
                </div>
            </div>
        </div>
        <!--page content-->
        <div class="page-sidebar" v-if="windowWidth > 767">
            <div class="contactInfoBtn" v-on:click.prevent="showContact()" >
                <i class="openCloseBtn fa fa-caret-right"></i>
            </div>
            <div class="contactDetails">
                <template v-if="userData.id != 0">
                    <div class="sidebar-locations">
                        {{userData.user}}
                    </div>
                    <template v-if="userData.address_line != '' || userData.note != '' || userData.email != '' || userData.contacts.length > 0 || userData.contact != ''">
                        <div v-if="userData.address_line != ''" class="sidebar-locations-details">
                            <img src="/static/images/map-pin.png">
                            {{userData.address_line}}
                        </div>
                        <div v-if="userData.note != ''" class="sidebar-locations-details mt-0">
                            Note : {{userData.note}}
                        </div>
                        <div class="primary-contact">
                            <p >Email :</p> <strong>{{userData.email}}</strong>
                        </div>
                        <template v-if="userData.contacts.length > 0 || userData.contact != ''">
                            <ul>
                                <li v-if="userData.contact != ''">
                                    <span >Extension :</span>
                                    {{userData.contact}}
                                </li> 

                                <template v-for="(cont, index1) in userData.contacts">
                                    <li>
                                        <span v-if="cont.contact_label != ''">{{cont.contact_label}} :</span>
                                        {{cont.contact}}
                                    </li>                                    
                                </template>
                            </ul>
                        </template>
                    </template>
                    <template v-else>
                        <div class="sidebar-locations-details">
                            {{noDataMessaage}}
                        </div>    
                    </template>
                </template>
                <template v-if="department_id != 0">
                    <template v-for="(dept_cont, index) in departmentData">
                        <template v-if="dept_cont.department_id == department_id">
                            <div class="sidebar-locations">
                                {{dept_cont.dept_name}}
                            </div>
                            <template v-if="dept_cont.note !='' || dept_cont.address_line != '' || dept_cont.contacts.length > 0">
                                <div v-if="dept_cont.address_line != ''" class="sidebar-locations-details">
                                    <img src="/static/images/map-pin.png">
                                    {{dept_cont.address_line}}
                                </div>
                                <div class="sidebar-locations-details mt-0" v-if="dept_cont.note != ''">
                                    <!-- <p >Note :</p>  -->
                                    <!-- <strong> -->
                                    Note : {{dept_cont.note}}
                                    <!-- </strong> -->
                                </div>
                                <div class="primary-contact">
                                    <p v-show="dept_cont.contacts[0].contact_label != ''">
                                        {{dept_cont.contacts[0].contact_label}} :
                                    </p> <strong>{{dept_cont.contacts[0].contact}}</strong>
                                </div>
                                <template v-if="dept_cont.contacts.length > 1">
                                    <ul>
                                        <template v-for="(cont, index1) in dept_cont.contacts">
                                            <template v-if="index1 != 0">
                                                <li>
                                                    <span v-if="cont.contact_label != ''">{{cont.contact_label}} :</span>
                                                    {{cont.contact}}
                                                </li>                                    
                                            </template>
                                        </template>
                                    </ul>
                                </template>
                            </template>
                            <template v-else>
                                <div class="sidebar-locations-details">
                                    {{noDataMessaage}}
                                </div>    
                            </template>
                        </template>
                    </template>
                </template>
                <div class="sidebar-locations">
                    {{departmentData[0].site_name}}
                </div>
                <template v-if="departmentData[0].site_note != '' || departmentData[0].site_address_line != '' || departmentData[0].site_contacts.length > 0">
                    <div v-if="departmentData[0].site_address_line != ''" class="sidebar-locations-details">
                        <img src="/static/images/map-pin.png">
                        {{departmentData[0].site_address_line}}
                    </div>
                    <div v-if="departmentData[0].site_note != ''" class="sidebar-locations-details mt-0">
                        Note : {{departmentData[0].site_note}}
                    </div>
                    <template v-if="departmentData[0].site_contacts.length > 0">
                        <div class="primary-contact">
                            <p v-show="departmentData[0].site_contacts[0].contact_label != ''">
                                {{departmentData[0].site_contacts[0].contact_label}} :
                            </p> <strong>{{departmentData[0].site_contacts[0].contact}}</strong>
                        </div>
                        <template v-show="departmentData[0].site_contacts.length > 1">
                            <ul>
                                <template v-for="(cont, index) in departmentData[0].site_contacts">
                                    <template v-if="index != 0">
                                        <li>
                                            <span v-if="cont.contact_label != ''">{{cont.contact_label}} :</span>
                                            {{cont.contact}}
                                        </li>                                    
                                    </template>
                                </template>
                            </ul>
                        </template>
                    </template>
                </template>
                <template v-else>
                    <div class="sidebar-locations-details">
                        {{noDataMessaage}}
                    </div>    
                </template>
            </div>
        </div>
    </div>
    <app-backend-footer></app-backend-footer>
</div>
<!-- /#page-content-wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    import EventBus from '../../event-bus';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';

    /* Swiper for submenu tebs start */
    import 'swiper/dist/css/swiper.css';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    /* Swiper for submenu tebs end */

    var self;
    export default {
        name: 'ListBenefits',
        components: {
            'app-backend-footer': BackendFooter,
            swiper,
            swiperSlide,
        },
        mixins: [SessioMixin],
        data() {
            return {
                hideContactflag: false,
                userData: {
                    id: 0
                },
                departmentData: [{
                        site_contacts: []
                    }
                ],
                windowWidth: 0,
                noDataMessaage: 'Details not available',
                display_sidebar_on_load: false,
                department_id: 0,
                location: '',
                company: '',
                selected_menu_data: '',
                user_name: '',
                isShowLoggedinfields: true,
                userPermissions: ['add_contact_extension'],
                roleId: 0,
                roleName: 0,
                system_year: '',
                swiperOptionDepartments: {
                    slidesPerView: 6.5,
                    spaceBetween: 8,
                    freeMode: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        1500: {
                            slidesPerView: 5.5
                        },
                        1400: {
                            slidesPerView: 5.3
                        },
                        1300: {
                            slidesPerView: 4.7
                        },
                        1200: {
                            slidesPerView: 3.5
                        },
                        1000: {
                            slidesPerView: 3.2
                        },
                        667: {
                            slidesPerView: 3.2
                        },
                        480: {
                            slidesPerView: 2.3
                        },
                        360: {
                            slidesPerView: 1.5
                        }
                    }
                },
                sitesArr: [],
                firstLoad: 0,
                columns: [
                    {
                        label: 'Username',
                        field: 'user',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "User", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Post',
                        field: 'post',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Post", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Email',
                        field: 'email',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Email", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Location',
                        field: 'site_name',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Location", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Department',
                        field: 'department_name',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Department", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Extension',
                        field: 'contact',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Contact", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                            /*{
                             label: 'Updated At',
                             field: 'updated_at',
                             filterable: true,
                             filterOptions: {
                             //                            placeholder: "MM/DD/YYYY",
                             enabled: true, // enable filter for this column
                             placeholder: "MM/DD/YYYY", // placeholder for filter input
                             filterValue: '', // initial populated value for this filter
                             filterDropdownItems: [], // dropdown (with selected values) instead of text input
                             filterFn: this.onColumnFilter, //custom filter function that
                             trigger: "enter" //only trigger on enter not on keyup
                             }
                             },
                             {
                             label: 'Updated By',
                             field: 'updated_by',
                             filterable: true,
                             filterOptions: {
                             enabled: true, // enable filter for this column
                             placeholder: "Updated By", // placeholder for filter input
                             filterValue: '', // initial populated value for this filter
                             filterDropdownItems: [], // dropdown (with selected values) instead of text input
                             filterFn: this.onColumnFilter, //custom filter function that
                             trigger: "enter" //only trigger on enter not on keyup
                             }
                             },*/
                            /*{
                             label: 'Actions',
                             field: 'action',
                             html: true,
                             sortable: false,
                             thClass: 'disable-sorting',
                             },*/
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'user',
                        type: 'asc',
                    },
                },
                recordsCounts: "",
                selectedRows: 0,
            }

        },
        beforeMount: function () {
            self = this;
            self.checkLogin(window.location.href);
            var contactDetailOpen = localStorage.getItem("contact_detail_open");
            if (contactDetailOpen == 'true') {
                self.hideContactflag = false;
            } else {
                self.hideContactflag = true;
            }
            //self.checkLogin();
        },
        mounted: function () {
//            self = this;
            self.windowWidth = $(window).width();
            $(window).resize(function () {
                self.windowWidth = $(window).width();
                if (self.windowWidth > 767) {
                    $('.contacttDetails').hide();
                } else {
                    $('.contacttDetails').show();
                }
            });

            self.company = this.$route.params.company;
            self.location = this.$route.params.location;
            self.getPermissions();
            self.$nextTick(function () {
                self.loadLocationDepartment(self.company, self.location);
            });
            self.showContact(self.hideContactflag);
            /*self.getMenus();*/
            self.setWidthToContactContainer(550);
        },
        watch: {
            '$route'(to, from) {
                self.location = this.$route.params.location;
                self.company = this.$route.params.company;
                self.$nextTick(function () {
                    self.loadLocationDepartment(self.company, self.location);
                });
                /*if (self.display_sidebar_on_load) {
                 self.showContact(true);
                 }*/
                self.userData = {id: 0};
                /*console.log(self.location);*/
            }
        },
        methods: {
            showContact(hide) {
                hide = (hide === null || typeof (hide) === "undefined" || hide == '') ? false : hide;
                if (hide) {
                    window.localStorage.setItem("contact_detail_open", false);
                    self.hideContactflag = true;
                    $('.contactDetails').fadeOut();
                    setTimeout(function () {
                        $('.page-sidebar').addClass('zeroWidth');
                        if (self.windowWidth > 767) {
                            $('.page-sidebar').show();
                            $('.internal-container').removeClass('openDetailview');
                        } else {
                            $('.page-sidebar').hide();
                        }
                        $('.openCloseBtn').removeClass('fa-caret-right');
                        $('.openCloseBtn').addClass('fa-caret-left');
                    }, 300);
                } else {
                    var classavailable = $('.page-sidebar').attr('class');
                    if (typeof (classavailable) != 'undefined') {
                        if (classavailable.indexOf('zeroWidth') > 0) {
                            window.localStorage.setItem("contact_detail_open", true);
                            self.hideContactflag = false;
                            $('.page-sidebar').removeClass('zeroWidth');
                            if (self.windowWidth > 767) {
                                $('.page-sidebar').show();
                                $('.internal-container').addClass('openDetailview');
                            } else {
                                $('.page-sidebar').hide();
                            }
                            $('.openCloseBtn').removeClass('fa-caret-left');
                            $('.openCloseBtn').addClass('fa-caret-right');
                            $('.contactDetails').fadeIn();
                        } else {
                            window.localStorage.setItem("contact_detail_open", false);
                            self.hideContactflag = true;
                            $('.contactDetails').fadeOut();
                            setTimeout(function () {
                                $('.page-sidebar').addClass('zeroWidth');
                                if (self.windowWidth > 767) {
                                    $('.page-sidebar').show();
                                    $('.internal-container').removeClass('openDetailview');
                                } else {
                                    $('.page-sidebar').hide();
                                }
                                $('.openCloseBtn').removeClass('fa-caret-right');
                                $('.openCloseBtn').addClass('fa-caret-left');
                            }, 300);
                        }
                    } else {
                        window.localStorage.setItem("contact_detail_open", true);
                        self.hideContactflag = false;
                        $('.page-sidebar').removeClass('zeroWidth');
                        if (self.windowWidth > 767) {
                            $('.page-sidebar').show();
                            $('.internal-container').addClass('openDetailview');
                        } else {
                            $('.page-sidebar').hide();
                        }
                        $('.openCloseBtn').removeClass('fa-caret-left');
                        $('.openCloseBtn').addClass('fa-caret-right');
                        $('.contactDetails').fadeIn();
                    }
                }
                self.setWidthToContactContainer(350);
            },
            onRowClick(params) {
                self.userData = params.row;
                if (self.windowWidth > 767) {
                    if ($('.page-sidebar').attr('class').indexOf('zeroWidth') != -1) {
                        $('.contacttDetails').hide();
                        /*self.showContact();*/
                    }
                } else {
                    /* If Data available then hide it */
                    if ($(params.event.target.closest('.clickable').nextSibling).hasClass("contacttDetails")) {
                        $(params.event.target.closest('.clickable').nextSibling).remove();
                        return;
                    }

                    if (self.userData.id) {
                        /* generate html */
                        var html = '<tr class="contacttDetails">';
                        html += '<td colspan="' + self.columns.length + '">';
                        /* html += '<label>' + self.userData.user + '</label>';
                         html += '<p><span class="fa fa-map-marker" aria-hidden="true"></span>';
                         html += self.userData.address_line + '</p>'; 
                         html += '<p>Note : ' + self.userData.note + '</p>'; */
                        html += '<table class="table">';
                        if (self.userData.address_line.length) {
                            html += '<tr><td>Address</td><td>' + self.userData.address_line + '</td></tr>';
                        }
                        if (self.userData.note.length) {
                            html += '<tr><td>Note</td><td>' + self.userData.note + '</td></tr>';
                        }
                        html += '<tr><td>Email</td><td><a href="mailto:' + self.userData.email + '">' + self.userData.email + '</a></td></tr>';
                        html += '<tr><td>Extension</td><td>' + self.userData.contact + '</td></tr>';
                        $.each(self.userData.contacts, function (i) {
                            html += '<tr><td>' + self.userData.contacts[i].contact_label + '</td>';
                            html += '<td>' + self.userData.contacts[i].contact + '</td></tr>';
                        });
                        html += '</table>';
                        html += '</td>';
                        html += '</tr>';
                        $(html).insertAfter(params.event.target.closest('.clickable'));
                    }
                }
            },
            selectDepartment(id) {
                $('.contacttDetails').hide();
                self.department_id = id;
                if (self.department_id) {
                    //*self.showContact(true);*/
                    self.userData = {id: 0};
                }
                self.$nextTick(function () {
                    self.loadContacts();
                });
            },
            addContact() {
                self.$router.push('/backend/addcontact');
            },
            loadLocationDepartment(company, location) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        company: company,
                        location: location,
                        swiper: 1,
                    }
                };
                self.showLoader();
                HTTP.get("ce-getsitedepartment", config)
                        .then(function (response) {
                            self.departmentData = [];
                            // if (response.data.content.length > 0) {
                            $.each(response.data.content, function (i) {
                                if (i == 0) {
                                    self.selectDepartment(response.data.content[i].department_id);
                                }
                                self.departmentData.push(response.data.content[i]);
                            });
                            if (self.departmentData[0].site_note != '' || self.departmentData[0].site_address_line != '' || self.departmentData[0].site_contacts.length > 0) {
                                $(".page-sidebar").removeAttr("style");
                                setTimeout(function () {
                                    EventBus.$emit('blink-detail', true, true, );
                                    /*self.showContact(true);*/
                                }, (self.ContactSideDetailAutoCloseSeconds * 1000));
                            }
                            // }

                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadContacts();
            },
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadContacts();
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('id');
                    field: ('user');
                    field: ('note');
                    field: ('email');
                    field: ('post');
                    field: ('contact');
                    field: ('site_name');
                    field: ('department_name');
                    field: ('updated_at');
                    field: ('updated_by');
                }
                ;
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.post || filters.email || filters.note || filters.user || filters.id || filters.contact || filters.site_name || filters.department_name || filters.updated_at || filters.updated_by) {
                    self.loadContacts();
                }

            },
            selectionChanged() {
                self.selectedRows = (self.$refs['ContactExtensionList'].selectedRows).length;
                /*console.log(self.selectedRows);*/
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadContacts();
            },
            loadContacts: function () {
                $('.contacttDetails').hide();
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        department_id: self.department_id,
                        site_id: self.location,
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        messageData: self.message,
                        sort: self.serverParams.sort
                    }
                };
                self.showLoader();
                HTTP.get('listcontact', config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                            }
                            self.hideLoader();
                            self.$nextTick(function () {
                                self.toSlide();
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    self.error = err.response.data.message;
                                }
                            }
                            self.hideLoader();
                        })
            },
            toSlide: function () {
                if (typeof (self.departmentData) != 'undefined') {
                    if (self.departmentData.length > 0) {
                        $('.dept').removeClass("ActiveDept");
                        $.each(self.departmentData, function (key_sub, value_dept) {
                            if (self.department_id == value_dept.department_id) {
                                self.$refs.swiperDepartment.swiper.slideTo(value_dept.slide_id, 0);
                                $('#dept_' + self.department_id).addClass("ActiveDept");
                            }
                        });
                    }
                }
            },
            print: function (company, location) {
                let routeData = self.$router.resolve({name: 'PrintContactList', params: {company: company, location: location}});
                window.open(routeData.href, '_blank');
                //self.$router.push("/print/extensionslist/" + company + "/" + location);
            },
        }
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
        }
    });
    EventBus.$on('blink-detail', function (isLogin, is_blink) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.display_sidebar_on_load = is_blink;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/backend/contactextension/ViewContactList.vue